import { WebStorageStateStore } from 'oidc-client-ts'
import React from 'react'
import ReactDOM from 'react-dom'
import { AuthProvider } from 'react-oidc-context'
import App from './app/App'

function getCurrentUrl() {
  const url = new URL(window.location.href)
  url.searchParams.delete('state')
  url.searchParams.delete('session_state')
  url.searchParams.delete('code')
  return url.toString()
}

const oidcConfig = {
  authority:
    import.meta.env.VITE_KEYCLOAK_REALM_URI ||
    'https://login.techstarsdev.com/auth/realms/TechstarsDev',
  post_logout_redirect_uri: `${window.location.origin}/`,
  redirect_uri: getCurrentUrl(),
  silent_redirect_uri: `${window.location.origin}/silent-renew`,
  automaticSilentRenew: true,
  loadUserInfo: true,
  client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'ts-perks',
  response_type: 'code',
  scope: 'openid profile email',
  revokeAccessTokenOnSignout: true,
  monitorSession: true,
  checkSessionInterval: 5000,
  // Use localStorage instead of sessionStorage for cross-tab authentication state sharing
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

function onSignin() {
  window.history.replaceState({}, window.document.title, getCurrentUrl())
}

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig} onSigninCallback={onSignin}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
